import { ToolbarComponent } from './toolbar/toolbar';
import { DraggableFileDirective } from './draggableFile/draggableFile'
import { DataGridComponent } from './dataGrid/dataGrid';
import { SelectListComponent } from './selectList/selectList';
import { LoginDirective } from './login/sharebase-login.component';
import { PlaylistViewComponent} from './playlistView/playlistView.component';
import { ProgressDirective } from './progress/progress';
import { SearchBoxDirective } from './searchBox/searchBox';
import { FullTextSearchBoxDirective } from './fullText/searchBox/searchBox';
import { ShareListDirective } from './shareList/shareList';
import { SubscriptionSelectorComponent } from './subscriptionSelector/subscriptionSelector'
import { VirtualizeTileViewDirective } from './virtualTileContainer/virtualTileContainer';
import { UserSelectComponent } from './userSelect/userSelect';
import { MentionsInputDirective } from './mentionsInput/mentionsInput.component';
import { ShowExperimentVariationDirective } from './showExperimentVariation/showExperimentVariation';
import { StickyHeaderDirective } from './stickyHeader/stickyHeader'
import { 
	CalendarHeatMapComponent, 
	HightlightDaysDirective 
} from './calendarHeatMap/calendarHeatMap';
import { HelpBlurbDirective } from './help-blurb/help-blurb.component';
import { defaultErrorMessages } from './defaultErrorMessages/errorMessages.component';
import { MyAccountDirective } from './myAccount/myAccount.component';
import { StatsListDirective } from './myAccount/statsList/statsList.component';
import { NotificationSettingsDirective } from './myAccount/notificationSettings/notificationSettings';
import { TimeZonePickerDirective } from './timeZonePicker/timeZonePicker';
import { TrackClickDirective } from './trackClick/trackClick';
import { ChipsInputFocusDirective } from './chipsInputFocus/chipsInputFocus';
import { TrackFormSubmissionDirective } from './trackFormSubmission/trackFormSubmission';
import { PersistentTableDirective } from './persistentTable/persistentTable';
import { DateRangePickerComponent } from './dateRange/dateRange.component';
import { SurveyRequestService }  from './surveyRequest/surveyRequest.service';
import { MediaViewerDirective } from './mediaViewer/mediaViewer';
import { UserSelectListDialog } from './userListSelectDialog/userListSelectDialog';
import {
	 VerticalStepperDirective, 
	 VerticalStepDirective
} from './verticalStepper/verticalStepper';
import { PromptDialog } from './promptDialog/promptDialog';
import { ConfirmDialog } from './confirmDialog/confirmDialog';
import { AddFocusDirective } from './addFocus/addFocus';
import { ShareBaseGridComponent } from './grid/grid';
import { ShareBaseCardListComponent } from './cardList/cardList';
import { DownloadDesktopDialog } from './downloadDesktopDialog/downloadDesktopDialog';
import { ExpirationPickerComponent } from './expiration-picker/expiration-picker';
import { EmptyStateComponent } from './emptyState/emptyState.component';
import { ShareBaseIconComponent } from './shareBaseIcon/shareBaseIcon.component';

export const componentsModule = angular
	.module('sharebase.component', [
		'phoenix',
		'sharebase.services',
		'util',
		'phoenix',
		'md.data.table',
		'ui.router'
	])
	.component('sbEmptyState', EmptyStateComponent)
	.component('sbIcon', ShareBaseIconComponent)
	.directive('sbDraggableFile', DraggableFileDirective)
	.component('sbToolbar', ToolbarComponent)
    .component('sbDataGrid', DataGridComponent)
	.component('sbSelectList', SelectListComponent)
	.directive('sbLogin', LoginDirective)
	.service('sbUserSelectListDialog', UserSelectListDialog)
	.directive('sbProgress', ProgressDirective)
	.directive('sbSearchBox', SearchBoxDirective)
	.directive('sbShareList', ShareListDirective)
	.component('sbSubscriptionSelector', SubscriptionSelectorComponent)
	.directive('sbVirtualTileContainer', VirtualizeTileViewDirective)
	.component('sbUserSelect', UserSelectComponent)
	.directive('sbMentionsInput', MentionsInputDirective)
	.directive('sbShowExperimentVariation', ShowExperimentVariationDirective)
	.directive('sbStickyHeader',StickyHeaderDirective)
	.directive('sbFullTextSearchBox', FullTextSearchBoxDirective)
	.directive('sbHighlightDays', HightlightDaysDirective)
	.component('sbCalendarHeatMap', CalendarHeatMapComponent)
	.component('sbPlaylistView', PlaylistViewComponent)
	.directive('defaultErrorMessages', defaultErrorMessages)
	.directive('pxMyAccount',  MyAccountDirective)
    .directive('pxStatsList', StatsListDirective)
	.directive('pxNotificationSettings', NotificationSettingsDirective)
	.directive('sbTimeZonePicker', TimeZonePickerDirective)
	.directive('sbTrackClickAction',TrackClickDirective)
	.directive('sbChipsInputFocus',ChipsInputFocusDirective)
	.directive('sbPersistentTable', PersistentTableDirective)
	.directive('sbTrackFormSubmission', TrackFormSubmissionDirective)
	.component('sbDateRange', DateRangePickerComponent)
	.service('sbSurveyRequestService', SurveyRequestService)
	.directive('sbMediaViewer', MediaViewerDirective)
	.directive('sbHelpBlurb', HelpBlurbDirective)	
	.directive('sbVerticalStepper', VerticalStepperDirective)
	.service('sbPromptDialog', PromptDialog)
	.service('sbConfirmDialog', ConfirmDialog)
	.directive('sbVerticalStep', VerticalStepDirective)
	.directive('sbAddFocus', AddFocusDirective)
	.component('sbGrid', ShareBaseGridComponent)
	.component('sbCardList', ShareBaseCardListComponent)
	.service('sbDownloadDesktopDialog', DownloadDesktopDialog)
	.component('sbExpirationPicker', ExpirationPickerComponent);
	
export * from './downloadDesktopDialog/downloadDesktopDialog';
export * from './virtualTileContainer/virtualTileContainer';



// WEBPACK FOOTER //
// ./src/sharebase/components/index.ts